import { NgModule, Component, Input, ChangeDetectionStrategy, PLATFORM_ID, Inject } from '@angular/core';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { DEVICE_INFO, DeviceInfo } from 'angular-engine/modules/ng-express-engine/tokens';

@Component({
    selector: 'mobile-spotlight',
    templateUrl: 'mobile-spotlight.template.html',
    styleUrls: ['mobile-spotlight.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileSpotlightComponent {
    @Input() items: any;
    public isServer:boolean = false;
    public isPhone:boolean = false;
    public activeItem:any;
    
    /**
     * ContentList component
     */
    constructor(@Inject(PLATFORM_ID) platformId: string,
                @Inject(DEVICE_INFO) private deviceInfo: DeviceInfo) {
        this.isServer = isPlatformServer(platformId);
        this.isPhone = deviceInfo.isPhone;
    }

}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/spotlight/mobile-spotlight/mobile-spotlight.component.ts